import { Controller } from "@hotwired/stimulus"
import { useOutlets } from "hb/insights/use_outlets"

export default class extends Controller {
  connect() {
    useOutlets(this)
  }
}
